import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { withFirebase } from "../Firebase";
import { AuthUserContext } from "../Session";

const SingOutConfirm = (props) => {
  const { open, close, firebase } = props;
  const { t } = useTranslation();

  const [doingLogOut, setdoingLogOut] = useState(false);

  const handleClose = () => close(false);

  const handleLogOut = () => {
    firebase.doSignOut();
    setdoingLogOut(true);
  };

  return (
    <AuthUserContext.Consumer>
      {(authUser) => (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} maxWidth={"xs"}>
          <DialogTitle id="simple-dialog-title">{t("quieres_cerrar_la_sesion", { name: authUser.displayName })}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("puedes_volver_a_iniciar_sesión_en_cualqier_momento._Si_no_quieres_cerrar_sesión_pulsa_en_cancelar")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} style={{ textTransform: "none" }}>
              {t("cancelar")}
            </Button>
            <Button onClick={handleLogOut} color="primary" variant="outlined" autoFocus style={{ textTransform: "none" }} disabled={doingLogOut}>
              {t("cerrar_sesion")}
              {doingLogOut && (
                <CircularProgress
                  size={24}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: -12,
                    marginLeft: -12,
                  }}
                />
              )}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </AuthUserContext.Consumer>
  );
};

export default withFirebase(SingOutConfirm);
